import { format } from "date-fns";
import { v4 as uuidv4 } from 'uuid';

export const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
    }).format(amount);
};

export const formatDate = (dateString) => {
    if (!dateString) {
        return "Invalid date";
    }
    const date = new Date(dateString);
    return format(date, "dd MMM yyyy, hh:mm a");
};

export const getDeviceId = () => {
    // Check if device ID already exists in local storage
    let deviceId = localStorage.getItem('foodo_device_id');

    // If not, generate a new one
    if (!deviceId) {
        // Generate a random ID (UUID-like format)
        const deviceId = 'device_' + uuidv4();
        // Store it for future use
        localStorage.setItem('foodo_device_id', deviceId);
    }

    return deviceId;
};

export const truncateText = (text, maxLength = 100, addEllipsis = true) => {
    if (!text) return '';

    // If text is already shorter than maxLength, return it as is
    if (text.length <= maxLength) return text;

    // Otherwise, truncate the text at the specified length
    const truncated = text.substring(0, maxLength);

    // Add ellipsis if requested
    return addEllipsis ? truncated + '...' : truncated;
};